// extracted by mini-css-extract-plugin
module.exports = {"nextArrow":"_bf97420","prevArrow":"_35f6c53","outside":"_2b299dd"};